<template>
  <el-dialog
    title="选择地区"
    :visible.sync="dialogVisible"
    width="900px"
    :close-on-click-modal="false"
    @close="handleCancel"
  >
    <div class="area">
      <div class="area-left">
        <div class="area-left-top">
          <bi-button
            v-for="item in operateList"
            :key="item.value"
            :type="item.value == selectType ? 'blue' : 'gley'"
            @click="btnClick(item.value)"
            >{{ item.label }}</bi-button
          >
        </div>
        <div class="area-left-table">
          <div class="area-left-table-header">
            <div
              class="area-left-table-header-item"
              v-for="(item, index) in headerList"
              :key="index"
            >
              <span>{{ item }}</span>
            </div>
          </div>
          <div class="area-left-table-body">
            <div class="area-left-table-body-box">
              <el-checkbox-group v-model="provinceAll" @change="provinceChange">
                <div
                  class="area-left-table-body-box-group-item"
                  v-for="item in dataList"
                  :key="item.title"
                >
                  <el-checkbox :value="item.title" :indeterminate="item.indeterminate">{{
                    item.name
                  }}</el-checkbox>
                  <div
                    class="area-left-table-body-box-group-item__icon"
                    @click="selectProvince(item)"
                  >
                    <i class="el-icon-arrow-right"></i>
                  </div>
                </div>
              </el-checkbox-group>
            </div>
            <div class="area-left-table-body-box">
              <el-checkbox-group
                v-if="!centralCity.includes(provinceValue) && provinceValue"
                v-model="selectCityArr"
                @change="cityChange"
              >
                <div
                  class="area-left-table-body-box-group-item"
                  v-for="item in cityList"
                  :key="item.title"
                >
                  <el-checkbox :value="item.title">{{ item.name }}</el-checkbox>
                </div>
              </el-checkbox-group>
              <div v-else class="area-left-table-body-box__tip">
                <span>请先选择省</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="area-right">
        <div class="area-right-top">
          <div class="area-right-top-left">
            <span>已选</span>
            <span class="area-right-top-left__num">{{ getCheckedValue.length }}</span>
            <span>个</span>
          </div>
          <div class="area-right-top-right">
            <span @click="cancelAll">清空</span>
          </div>
        </div>
        <div class="area-right-list" v-if="getCheckedValue.length">
          <div class="area-right-list-item" v-for="item in getCheckedValue" :key="item.city">
            <span class="area-right-list-item__label">{{ item.label }}</span>
            <div class="area-right-list-item__icon" @click="delItem(item)">
              <i class="el-icon-close"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <bi-button type="gley" @click="handleCancel">取 消</bi-button>
      <bi-button type="blue" @click="handleSure">确 定</bi-button>
    </span>
  </el-dialog>
</template>

<script>
import { getYqArea } from "@/api/common";
export default {
  name: "YSelectArea",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
      default: () => [],
    },
    platformCode: {
      type: String,
      default: "DY",
    },
  },
  data() {
    return {
      selectType: 1,
      dataList: [],
      cityList: [],
      selectCityArr: [],
      provinceValue: null,
      checked: {
        checkedArr: {},
      },
      provinceAll: [],
      operateList: [
        { label: "自定义", value: 1 },
        { label: "全选", value: 2 },
        { label: "全不选", value: 3 },
        { label: "排除偏远地区", value: 4 },
      ],
      headerList: ["选择省", "选择市"],
      centralCity: ["北京", "上海", "重庆", "天津"],
      pxoteProvince:
        this.platformCode == "YQ"
          ? ["新疆维吾尔自治区", "西藏自治区", "青海", "云南"]
          : ["新疆维吾尔自治区", "西藏自治区", "青海省", "云南省"],
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    getCheckedValue() {
      const keys = Object.keys(this.checked.checkedArr);
      if (keys.length) {
        const list = [];
        keys.forEach((key) => {
          const obj = this.dataList.find((item) => item.title == key);
          this.checked.checkedArr[key].forEach((item) => {
            list.push({
              label: `${obj.name}/${item.name}`,
              province: obj.title,
              city: item.title,
              cityName: item.name,
            });
          });
        });
        return list;
      }
      return [];
    },
  },
  watch: {
    value: {
      handler(val) {
        // 这里保留原来的 watch 逻辑
      },
      immediate: true,
    },
  },
  methods: {
    // 获取云雀地区数据
    async getYqList() {
      const res = await getYqArea();
      this.dataList = res.data.map((item) => item.children).flat();
    },
    btnClick(type) {
      this.selectType = type;
      if (type == 2) {
        this.selectAll();
      } else if (type == 3) {
        this.cancelAll();
      } else if (type == 4) {
        this.excludeRemote();
      }
    },
    // 省选择
    provinceChange(e) {
      // cleanHalfStatus();
      // 判断有选中的数据是否半选

      // 判断新增还是移除，且不移除半选的数据

      // checked.checkedArr = {};
      // 新增
      e.forEach((title) => {
        const obj = this.dataList.find((item) => item.title == title);
        this.checked.checkedArr[title] = obj.children;
        // 设置全选
        if (title == this.provinceValue) {
          this.selectCityArr.value = obj.children.map((item) => item.title);
        }
        // 取消半选
        obj.indeterminate = false;
      });
      const Keys = Object.keys(this.checked.checkedArr);
      // 获取数据差异
      const diffArr = e
        .filter((item) => !Keys.includes(item))
        .concat(Keys.filter((item) => !e.includes(item)));

      diffArr.forEach((diff) => {
        const obj = this.dataList.find((item) => item.title == diff);
        // 移除操作
        if (this.checked.checkedArr[diff].length == obj.children.length) {
          delete this.checked.checkedArr[diff];
          // 取消半选
          obj.indeterminate = false;
          // 移除市的选中
          if (diff == this.provinceValue) {
            this.selectCityArr.value = [];
          }
        }
      });
    },
    // 非全选
    cancelAll() {
      this.provinceAll = [];
      this.checked.checkedArr = {};
      this.selectCityArr.value = [];
      this.cleanHalfStatus();
    },
    // 清除半选状态
    cleanHalfStatus() {
      this.dataList.forEach((item) => {
        item.indeterminate = false;
      });
    },

    // ... 保留原来的方法，但需要修改 this 的引用方式
    handleCancel() {
      this.dialogVisible = false;
      this.$emit("cancle");
    },
    handleSure() {
      this.dialogVisible = false;
      let selectValue = this.getCheckedValue;
      if (this.platformCode == "JD") {
        selectValue = this.getCheckedValue.map((item) => {
          const codeObj = this.jdProvinceCode.find(
            (code) => item.province.indexOf(code.name) != -1
          );
          return {
            ...item,
            code: codeObj.code,
          };
        });
      }
      if (selectValue) this.$emit("comfirm", selectValue);
    },
  },
  created() {
    // if (this.platformCode == "JD") {
    //   this.getJdList();
    // } else if (this.platformCode == "DY" || this.platformCode == "TB") {
    //   this.getDyorTbList();
    // } else 
    if (this.platformCode == "YQ") {
      this.getYqList();
    }
  },
};
</script>

<style lang="scss" scoped>
.area {
  --themeColor: #007BFF;
  overflow: hidden;
  height: 543px;
  display: flex;
  &-left {
    height: 100%;
    flex: 1;
    border-right: 1px solid #f5f5f7;
    padding: 24px 16px 30px 24px;
    &-table {
      height: calc(100% - 46px);
      border-radius: 4px;
      border: 1px solid #edeff2;
      margin-top: 16px;
      &-header {
        display: flex;
        justify-content: space-between;
        background-color: #f4f4f4;
        height: 40px;
        line-height: 40px;
        border-bottom: 1px solid #edeff2;
        &-item {
          flex: 1;
          text-align: center;
          font-weight: 500;
          color: #333333;
        }
      }
      &-body {
        display: flex;
        height: calc(100% - 40px);
        &-box {
          flex: 1;
          padding: 12px 0px;
          overflow: auto;
          scrollbar-width: thin;
          :deep(.arco-checkbox-group) {
            width: 100%;
          }
          &-group {
            &-item {
              display: flex;
              justify-content: space-between;
              align-items: center;
              height: 30px;
              line-height: 30px;
              color: #333;
              padding: 0px 12px;
              white-space: nowrap;
              &:hover {
                background-color: #f7f8fa;
              }
              &__icon {
                color: #666;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                flex: 1;
                cursor: pointer;
              }
            }
          }
          &__tip {
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #999;
          }
          & + & {
            border-left: 1px solid #edeff2;
          }
        }
      }
    }
  }
  &-right {
    flex-basis: 230px;
    padding: 24px 24px 30px 16px;
    color: #333;

    &-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 12px;
      border-bottom: 1px solid #edeff2;
      &-left {
        display: flex;
        align-items: center;
        &__num {
          color: var(--themeColor);
          margin: 0px 4px;
        }
      }
      &-right {
        color: var(--themeColor);
        cursor: pointer;
      }
    }
    &-list {
      height: calc(100% - 36px);
      overflow: auto;
      scrollbar-width: thin;
      &-item {
        display: inline-flex;
        align-items: center;
        padding: 4px 8px 3px 8px;
        background-color: #f4f4f4;
        border-radius: 2px;
        margin-top: 16px;
        max-width: 170px;
        &__icon {
          margin-left: 8px;
          cursor: pointer;
        }
        &__label {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
}
</style>
